import React from 'react';
import DisplayAndDeleteRoleContent from './DisplayAndDeleteRoleContent';

function DisplayAndDeleteRole({ roles, setRoles, rolesForAssignment, setRolesForAssignment, rolesForAssignmentDisplay, setRolesForAssignmentDisplay }) {

    return (
        <div className='mt-3'>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Current Roles</label>
            <ul className="border border-gray-200 dark:border-slate-700 rounded-lg">
                {roles.map((role) => (
                    <DisplayAndDeleteRoleContent
                        key={role}
                        role={role}
                        roles={roles}
                        setRoles={setRoles}
                        rolesForAssignment={rolesForAssignment}
                        setRolesForAssignment={setRolesForAssignment}
                        rolesForAssignmentDisplay={rolesForAssignmentDisplay}
                        setRolesForAssignmentDisplay={setRolesForAssignmentDisplay}
                    />
                ))}
            </ul>
        </div>
    );
}

export default DisplayAndDeleteRole;
